import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useColorMode } from "@chakra-ui/react";

const ThemeContext = createContext();

const THEME_KEY = "app-theme";

export function ThemeProvider({ children }) {
  const { setColorMode } = useColorMode();

  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem(THEME_KEY);
    const initial = saved === "light" || saved === "dark" ? saved : "light";
    document.documentElement.setAttribute("data-theme", initial);
    return initial;
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(THEME_KEY, theme);
    setColorMode(theme);
  }, [theme, setColorMode]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
